import Vue from 'vue'
import VueRouter from 'vue-router'
import userService from '../services/user.service'
Vue.use(VueRouter)

const routes = [

  {
    path: '/power-systems',
    name: 'PowerSystems',
    component: () => import('../views/PowerSystems'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/v2',
    name: 'SplitLandingPreview',
    component: () => import('../views/SplitLanding'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/',
    name: 'inicio',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/nuestrosProductos'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },

  {
    path: '/switchgears',
    name: 'Switchgears',
    component: () => import('../views/Switchgears'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/transformers',
    name: 'Transformers',
    component: () => import('../views/Transformers'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/electrical-services',
    name: 'ElectricalServices',
    component: () => import('../views/ElectricalServices'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/wholesale-distribution',
    name: 'WholesaleDistribution',
    component: () => import('../views/WholesaleDistribution'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/commercial-solar',
    name: 'CommercialSolar',
    component: () => import('../views/CommercialSolar'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/wire-cable',
    name: 'WireCable',
    component: () => import('../views/WireCable'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/data-centers',
    name: 'DataCenters',
    component: () => import('../views/DataCenters'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/conduit-fittings',
    name: 'ConduitFittings',
    component: () => import('../views/ConduitFittings'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/square-d-equipment',
    name: 'SquareDEquipment',
    component: () => import('../views/SquareDEquipment'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/residential-electrical',
    name: 'ResidentialElectrical',
    component: () => import('../views/ResidentialElectrical'),
    meta: { log: false, admin: false, auth: false }
  },

  // 14-ago-2026: 'electrical supply' es la busqueda con MEJOR CTR del sitio (16.7%) y no
  // habia pagina que la peleara; 'electrical supplier scottsdale az' salia en posicion 17.
  {
    path: '/electrical-supply-scottsdale',
    name: 'ElectricalSupplyScottsdale',
    component: () => import('../views/ElectricalSupplyScottsdale'),
    meta: { log: false, admin: false, auth: false }
  },

  // 14-ago-2026: Search Console mostraba ~3,000 impresiones al año en busquedas de
  // instalacion de generadores (posicion 10-12) sin una sola pagina de ese servicio.
  {
    path: '/generator-installation-phoenix',
    name: 'GeneratorInstallation',
    component: () => import('../views/GeneratorInstallation'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/commercial-electrical',
    name: 'CommercialElectrical',
    component: () => import('../views/CommercialElectrical'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/industrial-electrical',
    name: 'IndustrialElectrical',
    component: () => import('../views/IndustrialElectrical'),
    meta: { log: false, admin: false, auth: false }
  },

  // {
  //   path: '/projects',
  //   name: 'Projects',
  //   component: () => import('../views/Proveedores'),
  //   meta: {
  //     log: false,
  //     admin: false,
  //     auth: false,
  //   }
  // },

  
  {
    path: '/privacy-notice',
    name: 'Aviso de privacidad',
    component: () => import('../views/Aviso'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },

  {
    path: '/terms-and-conditions',
    name: 'Terminos y condiciones de uso',
    component: () => import('../views/Terminos'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/AboutTea'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactTea'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/careers',
    name: 'Careers',
    component: () => import('../views/Careers'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/Blog'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '/blog/thhn-xhhw-mc-cable-guide',
    name: 'BlogThhnXhhwMc',
    component: () => import('../views/blog/ThhnXhhwMcCable'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/ul-switchgear-lead-times',
    name: 'BlogUlSwitchgearLeadTimes',
    component: () => import('../views/blog/UlSwitchgearLeadTimes'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/square-d-qo-vs-homeline',
    name: 'BlogSquareDQoVsHomeline',
    component: () => import('../views/blog/SquareDQoVsHomeline'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/generac-vs-kohler-vs-cummins',
    name: 'BlogGeneracVsKohlerVsCummins',
    component: () => import('../views/blog/GeneracVsKohlerVsCummins'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/square-d-homeline-vs-eaton-br',
    name: 'BlogSquareDHomelineVsEatonBr',
    component: () => import('../views/blog/SquareDHomelineVsEatonBr'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/square-d-vs-eaton-vs-siemens',
    name: 'BlogSquareDVsEatonVsSiemens',
    component: () => import('../views/blog/SquareDVsEatonVsSiemens'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/solar-epc-material-releases',
    name: 'BlogSolarEpcMaterialReleases',
    component: () => import('../views/blog/SolarEpcMaterialReleases'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/emt-rmc-pvc-conduit-guide',
    name: 'BlogEmtRmcPvcConduit',
    component: () => import('../views/blog/EmtRmcPvcConduit'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/panel-upgrade-200-vs-400-amp-arizona',
    name: 'BlogPanelUpgrade200vs400',
    component: () => import('../views/blog/PanelUpgrade200vs400Amp'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/commercial-panelboard-upgrade-arizona',
    name: 'BlogCommercialPanelboardUpgrade',
    component: () => import('../views/blog/CommercialPanelboardUpgrade'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/commercial-electrician-cost-phoenix',
    name: 'BlogCommercialElectricianCostPhoenix',
    component: () => import('../views/blog/CommercialElectricianCostPhoenix'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/how-to-choose-commercial-electrician-arizona',
    name: 'BlogHowToChooseCommercialElectricianArizona',
    component: () => import('../views/blog/HowToChooseCommercialElectricianArizona'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/phoenix-electrical-contractor-2026',
    name: 'BlogPhoenixElectricalContractor2026',
    component: () => import('../views/blog/PhoenixElectricalContractor2026'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/wire-cable-transformer-distribution-arizona-2026',
    name: 'BlogWireCableTransformerDistributionAz2026',
    component: () => import('../views/blog/WireCableTransformerDistributionAz2026'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/jst-padmount-vs-polemount-transformer-arizona',
    name: 'BlogJstPadMountVsPoleMount',
    component: () => import('../views/blog/JstPadMountVsPoleMount'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/how-to-size-commercial-transformer-arizona',
    name: 'BlogHowToSizeCommercialTransformerArizona',
    component: () => import('../views/blog/HowToSizeCommercialTransformerArizona'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/commercial-electrical-permit-phoenix',
    name: 'BlogCommercialElectricalPermitPhoenix',
    component: () => import('../views/blog/CommercialElectricalPermitPhoenix'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/solar-pv-installation-timeline-arizona',
    name: 'BlogSolarPvInstallationTimelineArizona',
    component: () => import('../views/blog/SolarPvInstallationTimelineArizona'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/arizona-summer-heat-electrical-derating',
    name: 'BlogArizonaSummerHeatDerating',
    component: () => import('../views/blog/ArizonaSummerHeatDerating'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/rfp-electrical-materials-arizona-guide',
    name: 'BlogRfpElectricalMaterialsArizonaGuide',
    component: () => import('../views/blog/RfpElectricalMaterialsArizonaGuide'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/us-mx-electrical-project-coordination',
    name: 'BlogUsMxElectricalCoordination',
    component: () => import('../views/blog/UsMxElectricalCoordination'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/ev-charger-installation-arizona',
    name: 'BlogEvChargerInstallationAz',
    component: () => import('../views/blog/EvChargerInstallationAz'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/solar-pv-main-panel-interconnection-arizona',
    name: 'BlogSolarPvMainPanelInterconnection',
    component: () => import('../views/blog/SolarPvMainPanelInterconnection'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/whole-home-generator-install-phoenix',
    name: 'BlogWholeHomeGeneratorPhoenix',
    component: () => import('../views/blog/WholeHomeGeneratorPhoenix'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/residential-service-mast-replacement-arizona',
    name: 'BlogResidentialServiceMastReplacement',
    component: () => import('../views/blog/ResidentialServiceMastReplacement'),
    meta: { log: false, admin: false, auth: false }
  },
  {
    path: '/blog/switchgear-vs-panelboard-arizona',
    name: 'BlogSwitchgearVsPanelboard',
    component: () => import('../views/blog/SwitchgearVsPanelboard'),
    meta: { log: false, admin: false, auth: false }
  },

  {
    path: '*',
    name: '404',
    component: () => import('../views/Error404'),
    meta: {
      log: false,
      admin: false,

      auth: false
    }
  },


]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach(async (to, from, next) => {

  let meta_admin = to.matched.some(record => record.meta.admin);

  let meta_log = to.matched.some(record => record.meta.log);
  let meta_auth = to.matched.some(record => record.meta.auth);

  let tokenexp = await userService.tokenexp()
  let check = false //comprobar si esta logeado
  let admin = false;

  let type = ''

  if (tokenexp) { // ver que el token no este expirado.
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath') //limpiar el localstorage
    next()
  }


  let response = await userService.getData()

  if (response.status == 'error') {
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')
  }


  if (response.success) { //comprobar que sea un login valido.
    check = true;
    let isAdmin = userService.isAdmin(response.data);
    admin = isAdmin.admin;
    type = isAdmin.type;
  }

  let ath = await userService.getAth();

  // borrar el localstorage cada que vayamos a login.

  if (to.path === '/login' && check) {
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')

    next()
  }

  //redireccionamientos por rol.
  if (!meta_log) next();

  if (meta_log && !check) next('/login');

  if (meta_admin) {
    if (admin) {

      if (meta_auth) {
        if (ath) {
          next();
        } else {
          localStorage.removeItem('tkn')
          localStorage.removeItem('ath')
          next('/login')
        }
      } else { //...proximamente rutas que no requieran autentificacion
        next()
      }

    } else {
      localStorage.removeItem('tkn')
      localStorage.removeItem('ath')
      next('/')
    }
  } else {
    next()
  }

  if (to.hash) {
    const checkExist = setInterval(() => {
      const element = document.querySelector(to.hash);
      if (element) {
        clearInterval(checkExist);
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
    next();
  }

  if (to.path === from.path) {
    window.scrollTo(0, 0);
  }
  next();

  window.scrollTo({ top: 0, behavior: "instant" });
  next();
});




export default router
